// extracted by mini-css-extract-plugin
module.exports = {"p":"styles__p__3vuAT","h1":"styles__h1__151wR","h2":"styles__h2__1Z4qq","h3":"styles__h3__22AgD","h4":"styles__h4__13_ZZ","h5":"styles__h5__1B3n9"};